
const LOGOS = [
  { name: 'QCTO',          full: 'Quality Council for Trades & Occupations', src: '/accreditations/Accreditations_QCTO.png' },
  { name: 'SAQA',          full: 'South African Qualifications Authority',   src: '/accreditations/Accreditations_saqa.png' },
  { name: 'Services SETA', full: 'Services Sector Education & Training',     src: '/accreditations/Accreditations_servicesseta.png' },
  { name: 'TETA',          full: 'Transport Education Training Authority',   src: '/accreditations/Accreditations_teta.png' },
  { name: 'W&RSETA',       full: 'Wholesale & Retail SETA',                  src: '/accreditations/Accreditations_wandrseta.png' },
];

export default function TrustBadgesSection() {
  return (
    <section className="py-12 bg-[#f0f9f2] border-y border-[#c8e6cf]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <p className="text-center text-xs font-bold uppercase tracking-[0.16em] text-[#6b7280] mb-8">
          Accredited & Registered With
        </p>

        <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-12">
          {LOGOS.map(logo => (
            <div
              key={logo.name}
              title={logo.full}
              className="flex items-center justify-center grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
            >
              <img
                src={logo.src}
                alt={logo.full}
                className="h-20 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
